import { useQuery, useMutation } from '@tanstack/react-query';
import { searchUsers, likeUser, passUser, favoriteUser } from '../Services/User/Matching';
import { showErrorToast } from '../Utils/Utils';

// Hook for searching users
export const useSearchUsers = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: ['searchUsers', filters],
    queryFn: () => searchUsers(filters),
    staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
    refetchOnWindowFocus: false,
    retry: 1,
    onError: (error) => {
      console.error('Error fetching users:', error);
      showErrorToast(error.message || 'Failed to fetch users');
    },
    ...options,
  });
};

// Hook for liking a user
export const useLikeUser = () => {
  return useMutation({
    mutationFn: likeUser,
    onSuccess: (data) => {
      console.log('User liked successfully:', data);
      //   showSuccessToast('User liked successfully!');
    },
    onError: (error) => {
      console.error('Error liking user:', error);
      showErrorToast(error.message || 'Failed to like user');
    },
  });
};

// Hook for passing on a user
export const usePassUser = () => {
  return useMutation({
    mutationFn: passUser,
    onSuccess: (data) => {
      console.log('User passed successfully:', data);
      // Don't show success toast for pass action as it's less significant
    },
    onError: (error) => {
      console.error('Error passing user:', error);
      showErrorToast(error.message || 'Failed to pass user');
    },
  });
};

// Hook for favoriting a user
export const useFavoriteUser = () => {
  return useMutation({
    mutationFn: favoriteUser,
    onSuccess: (data) => {
      console.log('User favorited successfully:', data);
    },
    onError: (error) => {
      console.error('Error favoriting user:', error);
      showErrorToast(error.message || 'Failed to favorite user');
    },
  });
};
